export const constRef = {
    searchBox: {

        padding: '10px 16px',
        fontSize: '18px',
        lineHeight: '1.3333333',
        borderRadius: '6px',
        display: 'block',
        fontWeight: '400',
        color: '#495057',
        backgroundColor: '#fff',
        backgroundClip: 'padding-box',
        border: '1px solid #ced4da',
        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
    },
    chips: {
        fontSize: '15px',
        fontWeight: '400'

    },
    option: {
        fontSize: '15px',
        fontWeight: '400'
    },
    optionsRef: [
        'ReactJs',
        'Angular',
        'Frontend',
        'Java',
        'PHP',
        'Database',
        'Hardware Issues',
        'Installations',
        'AWS',
        'Design',
        'App Development',
        'Website Development',
        'Android App Development',
        'IOS App Development',
        'Cloud',
        'Bigdata',
        'Machine Learning',
        'AI',
        'Python',
        'Others'
    ],
};


